export default {
  name: 'collect',
  path: '/collect',
  component: () => import('@/views/home/collect/collect.vue'),
  children: [
    {
      name: 'index', // 首页
      path: '',
      component: () => import('@/views/home/collect/index')
    },
    {
      name: 'collect-detail', // 详情
      path: 'detail',
      component: () => import('@/views/home/collect/detail')
    },
    {
      name: 'collect-edit', // 集采订单
      path: 'edit',
      component: () => import('@/views/home/collect/edit')
    },
    {
      name: 'collect-address', // 集采订单
      path: 'address',
      component: () => import('@/views/home/collect/address')
    },
    {
      name: 'collect-project', // 集采订单
      path: 'project',
      component: () => import('@/views/home/collect/project')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/collect.js